// extracted by mini-css-extract-plugin
module.exports = {"logo":"LogoCloud_logo__ikFy2","fadeInOut":"LogoCloud_fadeInOut__nGDVK"};